import memoize from 'lodash.memoize';

export type MammoImageInfo = {
	imgLaterality?: string;
	position?: string;
	imageType?: string;
	mammoType?: string;
};

const extractMammoImageInfo: (displaySetInstanceUID, imageSet) => MammoImageInfo = memoize(
	(displaySetInstanceUID, image) => {
		const {
			Modality,
			BodyPartExamined,
			ImageType,
			NumberOfFrames,
			ViewPosition,
			AcquisitionDeviceProcessingDescription,
			ImageLaterality,
			SeriesDescription,
			Laterality,
			SharedFunctionalGroupsSequence
		} = image;
		if (Modality !== 'MG' || BodyPartExamined !== 'BREAST') {
			// console.log('skip MG and BREAST', displaySetInstanceUID);
			return {};
		}
		const finalLaterality = Laterality || SharedFunctionalGroupsSequence?.[0]?.FrameAnatomySequence?.[0]?.FrameLaterality;
		console.log('mammoImageType', image, {
			Modality,
			SeriesDescription,
			BodyPartExamined,
			ImageType,
			NumberOfFrames,
			ViewPosition,
			AcquisitionDeviceProcessingDescription,
			ImageLaterality,
			Laterality: finalLaterality
		});

		let imgLaterality = ImageLaterality || finalLaterality;
		let position = ViewPosition;
		if (!position) {
			if (AcquisitionDeviceProcessingDescription?.includes('CC')) {
				position = 'CC';
			} else if (AcquisitionDeviceProcessingDescription?.includes('MLO')) {
				position = 'MLO';
			}
		}

		if (!imgLaterality || !position) {
			if ((SeriesDescription as string).includes('R-CC')) {
				imgLaterality = 'R';
				position = 'CC';
			} else if ((SeriesDescription as string).includes('L-CC')) {
				imgLaterality = 'L';
				position = 'CC';
			} else if ((SeriesDescription as string).includes('R-MLO')) {
				imgLaterality = 'R';
				position = 'MLO';
			} else if ((SeriesDescription as string).includes('L-MLO')) {
				imgLaterality = 'L';
				position = 'MLO';
			}
		}

		let imageType = '2D';
		// if (ImageType) {
		// 	const imgTypes = ImageType.length ? ImageType : [ImageType];
		// 	(imgTypes as Array<string>).forEach((type) => {
		// 		if (type && (type.includes('SYNTHESIS') || type.includes('SLICE'))) {
		// 			imageType = '3D';
		// 		}
		// 	});
		// } else
		if (NumberOfFrames > 1) {
			imageType = '3D';
		}

		// bỏ qua ảnh INSIGHT và PROJ
		if (ImageType?.includes('INSIGHT') || ImageType?.includes('PROJ')) {
			// console.log('skip INSIGHT or PROJ', displaySetInstanceUID);
			return { imgLaterality, position, imageType };
		}

		const mammoType = `${imgLaterality}-${position}-${imageType}`;
		console.log('mammoType', `${displaySetInstanceUID}: ${mammoType}`);

		return { imgLaterality, position, imageType, mammoType };
	},
	(displaySetInstanceUID: string, _image) => {
		return displaySetInstanceUID;
	}
);

export default extractMammoImageInfo;
